var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dod15"},[_c('div',{ref:"pc",staticClass:"dod_mock"},[_c('div',{staticClass:"dod_mock_header"},[_c('div',{ref:"pcHeaderBg",staticClass:"dod_mock_header_bg"}),_c('h4',{ref:"pcHeaderTitle"},[_vm._v("Title")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }